<template>
  <div class="o-tile-list">
    <div class="h-section h-section--margin-base h-remove-child-margin h-remove-child-padding">
      <div v-if="hasItems" class="h-grid h-grid--row-gutter h-remove-child-padding-top">
        <div v-for="gathering in paginatedGatherings" :key="gathering.id" class="h-grid__col h-grid__col--xs-6 h-grid__col--md-4">
          <tile color="m-tile--primary" :url="gathering.url" :image="getImage(gathering)" :title="gathering.name" :description="gathering.rassemblement_description" :city="gathering.city">
            <businesses-snippet :businesses="gathering.businessesData" />
          </tile>
        </div>
      </div>
      <div v-else class="empty-list">
        <div class="magIcon" />
        <h2 class="o-snippet-list__items">{{ $t('list-no-result') }}</h2>
      </div>
      <pagination v-if="nbPages > 1" v-model="currentPage" :nbPages="nbPages" />
    </div>
  </div>
</template>

<script>
import Tile from '@/components/ui/tile'
import BusinessesSnippet from '@/components/ui/businesses-snippet.vue'
import Pagination from '@/components/ui/pagination'

export default {
  components: {
    Tile,
    BusinessesSnippet,
    Pagination
  },
  props: {
    gatherings: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentPage: 1,
      gatheringsPerPage: 9
    }
  },
  computed: {
    hasItems: function() {
      return this.gatherings.length > 0
    },
    paginatedGatherings: function() {
      const from = (this.currentPage - 1) * this.gatheringsPerPage
      const to = from + this.gatheringsPerPage
      return this.gatherings.slice(from, to)
    },
    nbPages: function() {
      return Math.ceil(this.gatherings.length / this.gatheringsPerPage)
    }
  },
  methods: {
    getImage: function(gathering) {
      if (gathering.image) {
        return gathering.image.medium
      }
      return ''
    }
  },
  watch: {
    gatherings() {
      this.currentPage = 1
    }
  }
}
</script>
